import {
   ChangeDetectionStrategy,
   Component,
   Inject,
   OnDestroy,
   OnInit,
   ViewChild,
   ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { noWhitespaceValidator } from 'src/app/common-components/validators/no-whitespace.validator';
import { getExtensionPhonePrivileges, getPresenceContactPrivileges } from 'src/app/privileges/privileges.selector';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { EditPresenceContactPrivileges } from '../../presence-contact-register/models/presence-contact-privileges';
import { editPresenceContactSubmit } from '../../presence-contact-register/state/presence-contact-register.actions';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-edit-presence-contact',
    styleUrls: ['./edit-presence-contact.component.scss'],
    templateUrl: './edit-presence-contact.component.html',
    standalone: false
})
export class EditPresenceContactComponent implements OnInit, OnDestroy, FormComponent {
   @ViewChild(EditPresenceContactComponent) editPresenceContactViewComponent: EditPresenceContactComponent;

   callState: Observable<CallState>;

   presenceContactPrivileges$: Observable<EditPresenceContactPrivileges>;
   extensionPhonePrivileges$: Observable<EditPresenceContactPrivileges>;
   selectedAccountId$: Observable<number | null>;

   presenceContactExtensionId: number;
   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   constructor(
      protected store: Store,
      private fb: FormBuilder,
      private dialogService: LcsDialogService,
      public dialogRef: MatDialogRef<EditPresenceContactComponent>,
      @Inject(MAT_DIALOG_DATA) private data: any
   ) {
      this.presenceContactPrivileges$ = this.store.pipe(select(getPresenceContactPrivileges));
      this.extensionPhonePrivileges$ = this.store.pipe(select(getExtensionPhonePrivileges));
      this.selectedAccountId$ = this.store.pipe(select(getSelectedAccountId));
      this.presenceContactExtensionId = this.data.presenceContact.extension.extensionId;
   }

   ngOnInit(): void {
      this.initializeForm();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   initializeForm(): void {
      this.form = this.fb.group({
         office: [this.data.presenceContact.office, [noWhitespaceValidator(), Validators.maxLength(255)]],
         dndStatus: [this.data.presenceContact.dndStatus, [noWhitespaceValidator(), Validators.maxLength(50)]],
         departmentExtensions: [this.data.presenceContact.departmentExtensions?.map((de) => ({ ...de })) || []],
      });
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         var fields = this.getFormSubmittedEvent();
         this.store.dispatch(
            editPresenceContactSubmit({
               dndStatus: this.form.value.dndStatus,
               office: this.form.value.office,
               extensionPhoneId: this.data.presenceContact.extensionPhoneId,
               extensionId: this.data.presenceContact.extension.extensionId,
               departmentExtensions: this.form.value.departmentExtensions,
               fields: fields,
            })
         );
      }
      this.dialogRef.close();
   }

   private getFormSubmittedEvent(): string[] {
      const dirtyFields: string[] = [];

      Object.keys(this.form.controls).forEach((controlName) => {
         const control = this.form.get(controlName);
         if (control?.dirty) {
            dirtyFields.push(controlName);
         }
      });

      return dirtyFields;
   }
}
